<ng-container *ngIf="vm$ | async as vm">

  <section class="is-flex is-family-semiBold text-14">
    <app-icon class="text-24 has-spacing-right-s is-cursor-pointer" name="next" [style.transform]="'rotate(180deg)'" (click)="close()"></app-icon>
    <app-text>{{ PowerLines[vm.group.rows[0].module.source_type]?.name | LANG }}</app-text>
    <app-text class="is-align-end text-grey-70">{{ 'common-app.__TOTAL_TITLE' | LANG }} :&nbsp;</app-text>
    <app-text>{{ vm.group.value | toDisplayValue : vm.measureType }}</app-text>
    &nbsp;
    <app-text unit [measureType]="vm.measureType"></app-text>
  </section>

  <app-consumption-line *ngFor="let row of vm.group.rows"
    [name]="row.module.name"
    [icon]="PowerLines[row.module.source_type]?.icon"
    [value]="row.value | toDisplayValue : vm.measureType"
    [color]="row.color"
    [ratio]="row.ratio * 100"
    [measureType]="vm.measureType">
  </app-consumption-line>

</ng-container>
